import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { IAuthenticationResult, IUser } from '../services';

@Injectable({
  providedIn: 'root',
})
export class MockAuthService {
  private _user: IUser = {} as IUser;

  public isAuthenticated(): Observable<boolean> {
    return this.getUser().pipe(map((u: IUser) => !!u));
  }

  public getUser(): Observable<IUser> {
    return of(this._user);
  }

  public setUser(user: IUser): Observable<IUser> {
    return of(this._user);
  }

  get isLoggedIn(): boolean {
    return false;
  }

  get user(): IUser {
    return this._user;
  }

  get tokenKey(): string {
    return '';
  }

  get tokenEndpoint(): string {
    return '';
  }

  public hasRole(role: string): boolean {
    return true;
  }

  public getAccessToken(): Observable<string> {
    return of('');
  }

  public async signIn(state: any): Promise<IAuthenticationResult> {
    return new Promise<IAuthenticationResult>(() => {});
  }

  public async completeSignIn(url: string): Promise<IAuthenticationResult> {
    return new Promise<IAuthenticationResult>(() => {});
  }

  public async signOut(state: any): Promise<IAuthenticationResult> {
    return new Promise<IAuthenticationResult>(() => {});
  }

  public async completeSignOut(url: string): Promise<IAuthenticationResult> {
    return new Promise<IAuthenticationResult>(() => {});
  }
}
